(function () {
    'use strict';
    angular.module('GorillaBoy.OfficeEditor')
    .directive('officeFormMessageHandler', ['$location',
        function ($location) {
            return {
                restrict: 'A',
                link: function (scope, element) {
                    scope.$on('postHostReady', function(event, data, targetOrigin){
                    	var message = {
    						"MessageId": "Host_PostmessageReady",
    						"SendTime": Date.now(),
    						"Values": { }
						};

                        // post message to iframe.
                        var iFrame = document.getElementById('office_frame');
                    	iFrame.contentWindow.postMessage(JSON.stringify(message), $location.protocol() + '://' + $location.host() + ':' + $location.port());
                    });
                },
            };
        }
    ]);
}());